import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const LOCKED_PATH_MSG = "Upgrade to Pro: unlock your 24/7 voice coach and all 28 side hustle paths.";

export const LockedPath = ({ opp }) => (
  <div className="max-w-3xl mx-auto px-5 pt-6" data-testid="locked-path">
    <Link to="/dashboard" className="text-xs font-mono-ui uppercase tracking-wider text-gray-400 hover:text-white" data-testid="back-dashboard">← Back</Link>
    <div className="mt-4 card-panel-elevated p-6 relative overflow-hidden min-h-[320px]">
      <div className="blur-sm select-none pointer-events-none opacity-60" aria-hidden="true">
        <div className="eyebrow text-[#FD0F10]">ESCAPE SCORE · {opp.escape_score}%</div>
        <h1 className="font-display text-2xl sm:text-3xl font-black mt-1">{opp.title}</h1>
        <p className="text-gray-400 mt-1 text-sm">{opp.tagline}</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-5">
          {[0, 1, 2, 3, 4, 5, 6, 7].map(i => <div key={i} className="h-14 bg-[#0B0C0E] border border-[#2A2E39] rounded" />)}
        </div>
      </div>
      <div className="absolute inset-0 backdrop-blur-sm bg-black/50 flex flex-col items-center justify-center text-center px-6">
        <Lock className="text-[#FD0F10]" />
        <div className="font-mono-ui text-xs uppercase tracking-wider mt-2 text-white">PRO Unlock</div>
        <p className="text-sm text-gray-200 mt-3 max-w-sm" data-testid="locked-path-msg">{LOCKED_PATH_MSG}</p>
        <Link to="/pro" className="mt-4 hero-accent px-5 py-2.5 rounded text-sm font-bold text-white" data-testid="locked-path-upgrade">Upgrade</Link>
      </div>
    </div>
  </div>
);
